import React from "react";
import { toast } from "react-toastify";

// AQUI NOS TRAJIMOS EL RETURN DEL FORMULARIO, ESTO ES SIN LOGICA SOLO EL FORM

 const RecetaFormularioForm = ({
   modoPreview,
   receta,
   paciente,
   setPaciente,
   pacientes,
   setPacienteId,
   handleAgregarPaciente,
   opcionesAsociacion,
   consultaId,
   setConsultaId,
   pacienteId,
   setConfig,
   config,
   medicamentos,
   setMedicamentos,
   firmaHabilitada,
   digitalON,
   setDigitalON,
   setFirmaOpen,
   setFirmaCreds,
   handleGuardar,
   guardandoReceta,
 }) => {
 
    const calcularEdadEnFecha = (fechaNacimiento, fechaReferencia) => {
    if (!fechaNacimiento || !fechaReferencia) return null;

    const fn = new Date(fechaNacimiento);
    const fr = new Date(fechaReferencia);

    if (isNaN(fn.getTime()) || isNaN(fr.getTime())) return null;

    let edad = fr.getFullYear() - fn.getFullYear();

    const mesRef = fr.getMonth();
    const diaRef = fr.getDate();
    const mesFn = fn.getMonth();
    const diaFn = fn.getDate();

    if (mesRef < mesFn || (mesRef === mesFn && diaRef < diaFn)) {
        edad--;
    }

    return edad;
    };

    const calcularMesesEnFecha = (fechaNacimiento, fechaReferencia) => {
    if (!fechaNacimiento || !fechaReferencia) return null;

    const fn = new Date(fechaNacimiento);
    const fr = new Date(fechaReferencia);

    if (isNaN(fn.getTime()) || isNaN(fr.getTime())) return null;

    let meses =
        (fr.getFullYear() - fn.getFullYear()) * 12 +
        (fr.getMonth() - fn.getMonth());

    if (fr.getDate() < fn.getDate()) {
        meses--;
    }

    return Math.max(0, meses);
    };

    const calcularEdadYModo = (fechaNacimiento, fechaReferencia) => {
    if (!fechaNacimiento || !fechaReferencia) {
        return { edad: null, modo: "ninguna" };
    }

    const meses = calcularMesesEnFecha(fechaNacimiento, fechaReferencia);

    if (meses !== null && meses < 12) {
        return {
        edad: meses,
        modo: "meses",
        };
    }

    const anios = calcularEdadEnFecha(fechaNacimiento, fechaReferencia);

    return {
        edad: anios,
        modo: "ninguna",
    };
    };

    const avisarSiEdadNoCuadra = (edadManual, modoManual, fechaNacimiento, fechaReferencia) => {
  if (!fechaNacimiento || !fechaReferencia) return;

  const meses = calcularMesesEnFecha(fechaNacimiento, fechaReferencia);
  const anios = calcularEdadEnFecha(fechaNacimiento, fechaReferencia);

  if (meses === null || anios === null) return;

  const edadManualNum =
    edadManual === "" || edadManual === null ? null : Number(edadManual);

  if (edadManualNum === null || Number.isNaN(edadManualNum)) return;

  let noCuadra = false;

  // Menor de 1 año: debe ir en meses y el número debe cuadrar
  if (meses < 12) {
    noCuadra = edadManualNum !== meses || modoManual !== "meses";
  } else {
    // 1 año o más: debe cuadrar en años
    // y el label puede ser "ninguna" o "anios"
    const modoValido = modoManual === "ninguna" || modoManual === "anios";
    noCuadra = edadManualNum !== anios || !modoValido;
  }

  if (noCuadra) {
    toast.warning(
      "Nota: Se modificó la edad calculada automáticamente.",
      { toastId: "edad-no-cuadra-receta" }
    );
  }
};
   return (
     <>

{/* Formulario de ingreso de datos */}
      {!modoPreview && (
          <div className="formulario-datos">
              <h2>{receta ? "Nueva Receta basada en recetas anteriores" : "Nueva Receta"}</h2>
  
              <label>Seleccionar Paciente:</label>
              <input
                  list="lista-pacientes"
                  placeholder="Selecciona o busca paciente..."
                  value={paciente}
                  onChange={(e) => {
                      setPaciente(e.target.value);
  
                      // 📢 Enviar mensaje a PreviewReceta cuando se selecciona un paciente
                      const pacienteSeleccionado = pacientes.find(p => {
                        const nombreCompleto = `${p.nombre} ${p.apellido_paterno}${p.apellido_materno ? ' ' + p.apellido_materno : ''}`;
                        return nombreCompleto === e.target.value;
                      });
  
                      if (pacienteSeleccionado) {
                          setPacienteId(pacienteSeleccionado.id);
                          window.postMessage({ type: "refreshPreviewReceta", paciente_id: pacienteSeleccionado.id }, "*");
                      }
                  }}
              />
              <datalist id="lista-pacientes">
                {pacientes
                  .sort((a, b) => a.nombre.localeCompare(b.nombre))
                  .map((p) => (
                    <option 
                      key={p.id} 
                      value={`${p.nombre} ${p.apellido_paterno}${p.apellido_materno ? ' ' + p.apellido_materno : ''}`} 
                    />
                  ))}
              </datalist>
  
              <button type="button" onClick={handleAgregarPaciente}>Agregar Paciente</button>

              {opcionesAsociacion.length > 0 && (
                <div className="campo-origen-receta">
                  <label>Asociar consulta:</label>
                  <select
                    value={consultaId || ""}
                   onChange={(e) => {
                    const value = e.target.value;
                    setConsultaId(value || null);

                    // Si elige "No asociar", no prellenamos nada
                    if (!value) return;

                    // 1️⃣ Buscar la opción seleccionada (historia o consulta)
                    const opcion = opcionesAsociacion.find(
                      (opc) => `${opc.tipo}-${opc.id}` === value
                    );
                    if (!opcion) return;

                    // 2️⃣ Buscar el paciente actual en el arreglo `pacientes`
                    const pacienteSeleccionado = pacientes.find(p => p.id === pacienteId);
                    // Calcula la edad desde la fecha de la receta que es lo correcto

                    let fechaNacimiento = pacienteSeleccionado?.fecha_nacimiento || null;
                    const fechaReferencia = config.fecha || new Date().toLocaleDateString("fr-CA");
                    const { edad: edadCalculada, modo: modoEdadCalculado } = calcularEdadYModo(
                    fechaNacimiento,
                    fechaReferencia
                    );
                    // 4️⃣ Pree llenar diagnóstico, signos, edad y fecha_nacimiento en config
                    setConfig((prev) => ({
                      ...prev,
                      diagnostico: opcion.diagnostico || prev.diagnostico || "",
                      diagnostico_snapshot: opcion.diagnostico  || prev.diagnostico || "",
                      tratamiento: opcion.plan_tratamiento || prev.tratamiento || "",
                      edad_en_emision: edadCalculada ?? prev.edad_en_emision ?? null,
                      edad_etiqueta_en_emision: modoEdadCalculado ?? prev.edad_etiqueta_en_emision ?? "ninguna",
                      fecha_nacimiento_en_emision:
                        fechaNacimiento ?? prev.fecha_nacimiento_en_emision ?? null,
                      signos_vitales_snapshot: {
                        ...(prev.signos_vitales_snapshot || {}),
                        ...(opcion.signos || {}),
                      },
                    }));
                    setMedicamentos(
                    opcion.medicamentos && opcion.medicamentos.length > 0
                        ? opcion.medicamentos
                        : [{ nombre: "", indicaciones: "" }]
                    );
                  }}
                  >
                    <option value="">No asociar (receta independiente)</option>

                    {opcionesAsociacion.map((opc) => (
                      <option
                        key={`${opc.tipo}-${opc.id}`}
                        value={`${opc.tipo}-${opc.id}`}
                      >
                        {opc.label}
                      </option>
                    ))}
                  </select>
                </div>
              )}

  
              <label>
                  Diagnóstico:
                  <input
                      type="text"
                      value={config.diagnostico || ""}
                      placeholder="Describa los diagnósticos realizados"
                      onChange={(e) => {
                          setConfig((prevConfig) => ({ ...prevConfig, diagnostico: e.target.value }));
                      }}
                  />
              </label>
            {/* Formulario de ingreso de datos */}
              <h3>Plan de tratamiento:</h3>
              <div style={{ marginTop: 12 }}>
                <label>Tratamiento:</label>
                {medicamentos.map((item, idx) => (
                  <div key={idx} style={{ display: "grid", gridTemplateColumns: "1fr 1fr auto", gap: 8, marginBottom: 8 }}>
                    <input
                      type="text"
                      placeholder="Medicamento (p. ej., Paracetamol 500 mg)"
                      value={item.nombre || ""}
                      onChange={(e) => {
                        const v = e.target.value;
                        setMedicamentos(prev => prev.map((m, i) => i === idx ? { ...m, nombre: v } : m));
                      }}
                    />
                    <input
                      type="text"
                      placeholder="Indicaciones (dosis, frecuencia, duración)"
                      value={item.indicaciones || ""}
                      onChange={(e) => {
                        const v = e.target.value;
                        setMedicamentos(prev => prev.map((m, i) => i === idx ? { ...m, indicaciones: v } : m));
                      }}
                    />
                    <div style={{ display: "flex", gap: 6 }}>
                      <button type="button" onClick={() => setMedicamentos(prev => prev.filter((_, i) => i !== idx))} disabled={medicamentos.length === 1}>–</button>
                      <button type="button" onClick={() => setMedicamentos(prev => [...prev, { nombre: "", indicaciones: "" }])}>+</button>
                    </div>
                  </div>
                ))}
              </div>

              <label>
                  Plan:
                  <input
                      type="text"
                      value={config.tratamiento || ""}
                      placeholder="Describa el plan (laboratorios, recomendaciones generales)"
                      onChange={(e) => {
                          setConfig((prevConfig) => ({ ...prevConfig, tratamiento: e.target.value }));
                      }}
                  />
              </label>
  
             <label>
                  Fecha:
                  <input
                      type="date"
                      value={config.fecha}
                        onChange={(e) => {
                        const nuevaFecha = e.target.value;

                        setConfig((prevConfig) => {
                            const { edad, modo } = calcularEdadYModo(
                                prevConfig.fecha_nacimiento_en_emision,
                                nuevaFecha
                            );

                            return {
                                ...prevConfig,
                                fecha: nuevaFecha,
                                edad_en_emision: edad,
                                edad_etiqueta_en_emision: modo,
                            };
                        });
                    }}
                  />
              </label>
          

              {/* Switch: Firmar digitalmente */}
              {firmaHabilitada && (
              <div style={{ display: "flex", alignItems: "center", gap: 8, margin: "10px 0" }}>
                <input
                  id="switch-digital"
                  type="checkbox"
                  checked={digitalON}
                  onChange={(e) => {
                    const on = e.target.checked;
                    setDigitalON(on);
                    if (on) {
                      setFirmaOpen(true);   // abre modal para .cer/.key/password
                    } else {
                      setFirmaCreds(null);  // limpia credenciales efímeras
                    }
                  }}
                />
                <label htmlFor="switch-digital"><strong>Receta digital</strong></label>
              </div>
            )}
            {/* TEMPORAL DEBUG: Edad */}
            {config.mostrarEdad && (
            <div className="mb-2">
                <label>Edad</label>
                <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                    <input
                        type="number"
                        value={config.edad_en_emision || ""}
                        onChange={(e) => {
                                const nuevoValor = e.target.value;

                                setConfig((prev) => {
                                    const next = { ...prev, edad_en_emision: nuevoValor };

                                    avisarSiEdadNoCuadra(
                                        nuevoValor,
                                        prev.edad_etiqueta_en_emision || "ninguna",
                                        prev.fecha_nacimiento_en_emision,
                                        prev.fecha
                                    );

                                    return next;
                                });
                            }}
                        className="form-control"
                    />

                    <select
                        value={config.edad_etiqueta_en_emision || "ninguna"}
                        onChange={(e) => {
                            const nuevoModo = e.target.value;

                            setConfig((prev) => {
                                const next = {
                                    ...prev,
                                    edad_etiqueta_en_emision: nuevoModo,
                                };

                                avisarSiEdadNoCuadra(
                                    prev.edad_en_emision,
                                    nuevoModo,
                                    prev.fecha_nacimiento_en_emision,
                                    prev.fecha
                                );

                                return next;
                            });
                        }}
                        className="form-control"
                        style={{ maxWidth: 160 }}
                    >
                        <option value="ninguna">Sin label</option>
                        <option value="meses">Meses</option>
                        <option value="anios">Años</option>
                    </select>
                </div>
            </div>
            )}
            {config.mostrarFechaNacimiento && (
            <div className="mb-2">
                <label>Fecha de nacimiento</label>
                <input
                    type="date"
                    value={config.fecha_nacimiento_en_emision || ""}
                    onChange={(e) =>
                        setConfig((prev) => ({
                            ...prev,
                            fecha_nacimiento_en_emision: e.target.value,
                        }))
                    }
                    className="form-control"
                />
            </div>
            )}
            
            {config.mostrarSignos && (
                <div className="mb-2">
                    <h3>Signos Vitales</h3>

                    {config.mostrarTA && (
                        <>
                            <label>Presión Arterial (mmHg)</label>
                            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                <input
                                    type="number"
                                    placeholder="120"
                                    value={config.signos_vitales_snapshot?.sistolica || ""}
                                    onChange={(e) =>
                                        setConfig((prev) => ({
                                            ...prev,
                                            signos_vitales_snapshot: {
                                                ...prev.signos_vitales_snapshot,
                                                sistolica: e.target.value,
                                            },
                                        }))
                                    }
                                />
                                <span>/</span>
                                <input
                                    type="number"
                                    placeholder="80"
                                    value={config.signos_vitales_snapshot?.diastolica || ""}
                                    onChange={(e) =>
                                        setConfig((prev) => ({
                                            ...prev,
                                            signos_vitales_snapshot: {
                                                ...prev.signos_vitales_snapshot,
                                                diastolica: e.target.value,
                                            },
                                        }))
                                    }
                                />
                            </div>
                        </>
                    )}

                    {config.mostrarFC && (
                        <>
                            <label>Frecuencia Cardiaca (lpm)</label>
                            <input
                                type="number"
                                placeholder="70"
                                value={config.signos_vitales_snapshot?.frecuencia_cardiaca || ""}
                                onChange={(e) =>
                                    setConfig((prev) => ({
                                        ...prev,
                                        signos_vitales_snapshot: {
                                            ...prev.signos_vitales_snapshot,
                                            frecuencia_cardiaca: e.target.value,
                                        },
                                    }))
                                }
                            />
                        </>
                    )}

                    {config.mostrarFR && (
                        <>
                            <label>Frecuencia Respiratoria (rpm)</label>
                            <input
                                type="number"
                                placeholder="16"
                                value={config.signos_vitales_snapshot?.frecuencia_respiratoria || ""}
                                onChange={(e) =>
                                    setConfig((prev) => ({
                                        ...prev,
                                        signos_vitales_snapshot: {
                                            ...prev.signos_vitales_snapshot,
                                            frecuencia_respiratoria: e.target.value,
                                        },
                                    }))
                                }
                            />
                        </>
                    )}

                    {config.mostrarTemp && (
                        <>
                            <label>Temperatura (°C)</label>
                            <input
                                type="number"
                                step="0.1"
                                placeholder="36.5"
                                value={config.signos_vitales_snapshot?.temperatura || ""}
                                onChange={(e) =>
                                    setConfig((prev) => ({
                                        ...prev,
                                        signos_vitales_snapshot: {
                                            ...prev.signos_vitales_snapshot,
                                            temperatura: e.target.value,
                                        },
                                    }))
                                }
                            />
                        </>
                    )}

                    {config.mostrarSpO2 && (
                        <>
                            <label>Saturación de Oxígeno (%)</label>
                            <input
                                type="number"
                                step="0.1"
                                placeholder="98"
                                value={config.signos_vitales_snapshot?.saturacion_oxigeno || ""}
                                onChange={(e) =>
                                    setConfig((prev) => ({
                                        ...prev,
                                        signos_vitales_snapshot: {
                                            ...prev.signos_vitales_snapshot,
                                            saturacion_oxigeno: e.target.value,
                                        },
                                    }))
                                }
                            />
                        </>
                    )}

                    <h3>Somatometría</h3>

                    {config.mostrarPeso && (
                        <>
                            <label>Peso (kg)</label>
                            <input
                                type="number"
                                step="0.01"
                                placeholder="70"
                                value={config.signos_vitales_snapshot?.peso || ""}
                                onChange={(e) =>
                                    setConfig((prev) => ({
                                        ...prev,
                                        signos_vitales_snapshot: {
                                            ...prev.signos_vitales_snapshot,
                                            peso: e.target.value,
                                        },
                                    }))
                                }
                            />
                        </>
                    )}

                    {config.mostrarTalla && (
                        <>
                            <label>Altura (m)</label>
                            <input
                                type="number"
                                step="0.01"
                                placeholder="1.75"
                                value={config.signos_vitales_snapshot?.altura || ""}
                                onChange={(e) =>
                                    setConfig((prev) => ({
                                        ...prev,
                                        signos_vitales_snapshot: {
                                            ...prev.signos_vitales_snapshot,
                                            altura: e.target.value,
                                        },
                                    }))
                                }
                            />
                        </>
                    )}

                    {config.mostrarIMC && (
                        <>
                            <label>IMC</label>
                            <input
                                type="number"
                                step="0.01"
                                placeholder="22.8"
                                value={config.signos_vitales_snapshot?.imc || ""}
                                onChange={(e) =>
                                    setConfig((prev) => ({
                                        ...prev,
                                        signos_vitales_snapshot: {
                                            ...prev.signos_vitales_snapshot,
                                            imc: e.target.value,
                                        },
                                    }))
                                }
                            />
                        </>
                    )}

                    {config.mostrarClasificacionIMC && (
                        <>
                            <label>Categoría IMC</label>
                            <input
                                type="text"
                                placeholder="Normal"
                                value={config.signos_vitales_snapshot?.categoria_imc || ""}
                                onChange={(e) =>
                                    setConfig((prev) => ({
                                        ...prev,
                                        signos_vitales_snapshot: {
                                            ...prev.signos_vitales_snapshot,
                                            categoria_imc: e.target.value,
                                        },
                                    }))
                                }
                            />
                        </>
                    )}

                </div>
            )}
             <button onClick={handleGuardar} disabled={guardandoReceta}>
              {guardandoReceta ? "Guardando…" : "Guardar Receta"}
            </button>
          </div>
      )}
    </>
   );
 };

 export default RecetaFormularioForm;
